import { Link } from "react-router-dom";
import { footerColumns, siteMeta } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                瓜
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-background-50">瓜链</span>
                <span className="text-[11px] text-secondary-300 mt-1 tracking-wide">GuaLink</span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-200 max-w-sm">
              {siteMeta.descriptor}。我们把热度值、话题量、转发量与扩散渠道整理成可对比的曲线，
              让「为什么会火」变成可以被读懂的过程。
            </p>
            <div className="mt-6 flex items-center gap-3 text-sm text-secondary-200">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line" />
              </span>
              <span>{siteMeta.email}</span>
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm text-secondary-200">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line" />
              </span>
              <span>{siteMeta.workHours}</span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-background-50 mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">内容声明</h4>
            <p className="text-sm text-secondary-200 leading-relaxed">
              本站仅做传播链路的结构化记录，不对事件本身下结论。涉及待核实信息会在页面明确标注。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            © {siteMeta.since} - 2026 {siteMeta.brand} · {siteMeta.tagline}
          </p>
          <p className="text-xs text-secondary-300">
            内容仅供传播观察与学习参考，请以当事人及官方发布为准
          </p>
        </div>
      </div>
    </footer>
  );
}